import React from "react"
import { Button, Form, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import Api_Config from "../../code/api/ApiConfig";
import CclCurrencyInput from "../common/CclCurrencyInput";

interface ICurrencyModalForm {
    modalActive: boolean;
    modalTitle: string;
    modalDescription: string;
    amount?: number;
    description?: string;
    onConfirm: (isConfirm: boolean, amount?: number, description?: string) => void;
}

export default function CurrencyModalForm({ modalActive, modalTitle, modalDescription, amount, description, onConfirm }: ICurrencyModalForm) {
    const [currentAmount, setCurrentAmount] = React.useState<number>(amount || 0);
    const [currentDescription, setCurrentDescription] = React.useState<string>(description || "");
    const company = Api_Config.getSelectedCompany();

    function onConfirmButtonClick() {
        onConfirm(true, currentAmount, currentDescription);
    }

    return (
        <Modal isOpen={modalActive} toggle={() => { onConfirm(false); }} >
            <ModalHeader toggle={() => { onConfirm(false); }}>{modalTitle}</ModalHeader>
            <ModalBody>
                <Form>
                    <div>
                        <Label>{modalDescription}</Label>
                    </div>
                    <Label className="form-label" htmlFor="cmodAmountInput">Amount</Label>
                    <CclCurrencyInput id="cmodAmountInput" className={"form-control"} currencyPrefix={company.currency} onChange={(value) => setCurrentAmount(value)} />
                    <Label className="form-label">Description</Label>
                    <Input type="text" className="form-control" onChange={(e) => { setCurrentDescription(e.target.value) }} />
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" disabled={!currentAmount || !currentDescription} onClick={onConfirmButtonClick}>Create</Button>{" "}
                <Button color="secondary" onClick={() => { onConfirm(false); }}>Cancel</Button>
            </ModalFooter>
        </Modal>
    )
}
